import React, { useState } from 'react';
import { LLreward } from './loyaltyTypes';
import { openSignInModal } from '../../../../../templates/_shared/ui-components/SignInModal/utils';
import { claimReward } from './loyaltyUtils';
import { CartData } from '../../../../../utils/cart';
import { RewardVariantSelector } from './RewardVariantSelector';
import { loyaltyState, openLoyaltyVariantSelectorModal } from './loyaltyState';
import { Customer } from '../../../../../utils/environment';
import { observer } from 'mobx-react-lite';

let RewardCard = ({
  reward,
  settings,
  cartData,
}: {
  reward: LLreward;
  settings: { redeemButtonText: string; shouldHideRedeemButton: boolean };
  cartData: CartData;
}) => {
  const { title, description, point_cost } = reward;
  const { redeemButtonText, shouldHideRedeemButton } = settings;
  const pointCost = `${point_cost} point${point_cost > 1 && 's'}`;
  const [isRedeeming, setIsRedeeming] = useState(false);
  const isAlreadyRedeemed = cartData.giftItemsAndLoyaltyRewards.find(
    (item) => item.properties._loyaltyRewardId === reward.id
  );
  const isCustomer = !!Customer.id;

  const isButtonDisabled =
    (isCustomer && !!isAlreadyRedeemed) ||
    (isCustomer && !!(loyaltyState.pointsBalance && loyaltyState.pointsBalance <= point_cost)) ||
    (isCustomer && isRedeeming);
  const getButtonText = () => {
    if (isCustomer) {
      if (!isButtonDisabled) {
        return redeemButtonText;
      } else if (isAlreadyRedeemed || isRedeeming) {
        return 'Already Redeemed';
      } else {
        return 'More Points Needed';
      }
    } else {
      return 'Sign In';
    }
  };

  const handleOnClick = async () => {
    const rewardMarket = reward.market?.trim().length > 0 ? reward.market : 'domestic';
    if (isCustomer && reward.target_products && reward.target_products.length === 1) {
      setIsRedeeming(true);
      await claimReward(reward.id, reward.target_products[0]!.variant_id.toString(), rewardMarket); // ? [REVISIT] Add UI feedback in case of fail
      setIsRedeeming(false);
    } else if (isCustomer && reward.target_products && reward.target_products.length > 1) {
      openLoyaltyVariantSelectorModal();
    } else {
      openSignInModal({ returnUrl: window.location.href });
    }
  };

  return (
    <>
      <div className="card">
        <img src={reward.target_products[0]?.image_url} alt="" className="img-fluid image" />
        <div className="info-container">
          <div className="info">
            <p className="title body-small semibold">{title}</p>
            <p className="points-cost tag-small uppercase">{pointCost}</p>
            <p className="description legal">{description}</p>
          </div>
          {shouldHideRedeemButton && isCustomer ? null : (
            <button
              disabled={isButtonDisabled}
              style={isButtonDisabled ? { cursor: 'not-allowed' } : {}}
              className="action-button button-primary-xs"
              type="button"
              onClick={handleOnClick}
            >
              {getButtonText()}
            </button>
          )}
        </div>
      </div>
      {reward.target_products?.length > 1 && <RewardVariantSelector reward={reward} buttonText={getButtonText()} />}
    </>
  );
};

RewardCard = observer(RewardCard);
export { RewardCard };
